import { render, staticRenderFns } from "./ItemReceipt.vue?vue&type=template&id=bd3d391c&scoped=true"
import script from "./ItemReceipt.vue?vue&type=script&lang=js"
export * from "./ItemReceipt.vue?vue&type=script&lang=js"
import style0 from "./ItemReceipt.vue?vue&type=style&index=0&id=bd3d391c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3d391c",
  null
  
)

export default component.exports